import { DatePipe, NgClass, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CurrentSubscription } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { PrettyCurrencyPipeModule } from '@rma/dashboard/generic/util/pipes/pretty-currency';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-billing-info-nav',
  imports: [DatePipe, NgClass, UpperCasePipe, MatCardModule, PrettyCurrencyPipeModule, TranslocoModule, RmaIconComponent, RouterModule],
  templateUrl: './billing-info-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingInfoNavComponent {
  @Input()
  public agencyName?: string;

  @Input()
  public profileName?: string;

  @Input()
  public subscription?: CurrentSubscription;

  @Input()
  public agentCount?: number;

  @Input()
  public showBillingLink = true;

  @HostBinding()
  public class = 'block';
}
